export default __webpack_public_path__ + "2942517.png";